import { useState, useEffect } from "react";
import { TitleHeader } from "../components/header/HeaderPage";
import Calendario from "../components/helpers/Calendario";
import { axiosInstance } from "../components/helpers/axiosInstance";
import dayjs from "dayjs";

// import { useEffect, useState, useMemo } from "react";
// import axios, { AxiosHeaders } from "axios";
// import { axiosInstance } from "../components/helpers/axiosInstance";
// import { TreePicker } from "rsuite"; //SelectPicker, Input
// import 'rsuite/TreePicker/styles/index.css'
// import Fuse from 'fuse.js';
// import Highlight from 'rsuite/Highlight';
// import 'rsuite/Highlight/styles/index.css';
// import {SistemaColor} from "../components/helpers/Sistema";
// import InputPicker from 'rsuite/InputPicker';
// import 'rsuite/InputPicker/styles/index.css';

import logo from "../assets/media/logos/buro/buro-isotipo-color.svg";

export default function Dashboard() {

    const [activity, setActivity] = useState([]);

    const { usuario } = JSON.parse(sessionStorage.getItem("user"));

    useEffect(() => {
        const today = dayjs().format('YYYY-MM-DD');

        axiosInstance.get(`/activity?fecha=${today}`)
            .then((response) => {
                if (Array.isArray(response.data)) {
                    setActivity(response.data)
                }
            }).catch((error) => {
                console.log(error);
        })
    },[]);

    function seccionItem(item){
        switch (item) {
            case 'ASISTENTE':
                return <i className="las la-user-tie fs-2 text-primary"></i>;
            case 'PARTES':
                return <i className="ki-outline ki-people fs-2 text-info"></i>;
            case 'BURO':
                return <img src={logo} className="h-20px" alt="Buro Judicial"/>;
            case 'HISTORIAL':
                return <i className="bi bi-archive fs-3 text-danger"></i>;
            case 'LOGIN' :
                return <i className="bi bi-box-arrow-in-right fs-3 text-success"></i>;
            case 'LOGOUT' :
                return <i className="bi bi-box-arrow-in-left fs-3 text-secondary"></i>;
            default :
                return <i className="bi bi-activity fs-3 text-secondary"></i>;

        }
    }

    return (
        <>
            <div className="content d-flex flex-column flex-column-fluid" id="kt_content">
                <div id="content_container" className="">
                    <div className="d-lg-none">
                        <TitleHeader/>
                    </div>

                    <div className={"m-5"}>
                        <div className="row">
                            <div className="col-12">
                                <div className="card">
                                    <div className="card-header ">
                                        <h3 className="card-title align-items-start flex-column">
                                            <span className="card-label fw-bold text-gray-800">Enlace Juridico</span>
                                            <span
                                                className="text-gray-500 mt-1 fw-semibold fs-6">Actividad reciente</span>
                                        </h3>
                                        <div className="card-toolbar">
                                            <Calendario setActivity={setActivity}></Calendario>
                                        </div>
                                    </div>
                                    <div className="card-body">
                                        <div className="timeline timeline-border-dashed">
                                            {
                                                (activity && activity.length > 0) ? (activity.map((item) => {
                                                    return (
                                                        <div key={item.hora} className="timeline-item">
                                                            <div className="timeline-line"></div>
                                                            <div className="timeline-icon">
                                                                {seccionItem(item.seccion)}
                                                            </div>
                                                            <div className="timeline-content mb-10 mt-n1">
                                                                <div className="pe-3 mb-5">
                                                                    <div
                                                                        className="fs-5 fw-semibold text-uppercase pb-1 ">{item.expediente ?? item.carpeta ?? item.parte}</div>
                                                                    <div className="d-flex align-items-center">
                                                                        <div className="symbol symbol-25px me-2">
                                                                            {/*  cambiar usuario*/}
                                                                            <span
                                                                                className={"symbol-label fs-8 " + usuario.avatar}>
                                                                            {usuario.avatar}
                                                                          </span>
                                                                        </div>
                                                                        <div
                                                                            className="text-muted fs-7 text-capitalize">
                                                                            {`${dayjs(item.fecha + item.hora).format("MMMM DD, YYYY - HH:mm:ss A")} - ${item.ip}`}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="overflow-auto">
                                                                    <div
                                                                        className="d-flex align-items-center border border-dashed border-gray-300 rounded px-3 py-3 mb-0">
                                                                        <div className="me-3">
                                                                            <i className="bi bi-clock-history"></i>
                                                                            <span
                                                                                className="fw-bold ms-1">{item.historico ?? 'TT'}</span>
                                                                        </div>

                                                                        <div
                                                                            className="fs-5 text-gray-900 text-uppercase fw-semibold">
                                                                            <i className="las la-gavel fs-6 me-1"></i>
                                                                            {item.juzgado ?? `${item.fecha_ini} - ${item.fecha_fin}`}
                                                                        </div>
                                                                        <div className="ms-auto">
                                                                            <span
                                                                                className="badge badge-light-success">OK</span>
                                                                            <i className="bi bi-filetype-pdf text-danger fs-4 d-none"></i>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    );
                                                })) : (
                                                    <div className={"position-relative"} style={{height: "10rem"}}>
                                                        <div
                                                            className={"position-absolute top-50 start-50 translate-middle"}>
                                                            <i className="ki-duotone ki-calendar-remove fs-5hx text-primary">
                                                                <span className="path1"></span>
                                                                <span className="path2"></span>
                                                                <span className="path3"></span>
                                                                <span className="path4"></span>
                                                                <span className="path5"></span>
                                                                <span className="path6"></span>
                                                            </i>
                                                        </div>
                                                        <br/>
                                                        <span
                                                            className={"position-absolute bottom-0 start-50 translate-middle-x fw-semibold fs-5"}> No hay datos para esa fecha </span>
                                                    </div>
                                                )
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </>
    );
}

// const options = {
//     keys: ['label', 'children.label'], // Claves que se búscaran en la cadena
//     // isCaseSensitive: false, //Distinguir entre mayúsculas y minúsculas
//     includeScore: true, // Puntuación de coincidencia, 0 perfecta, 1 no hay simulitud
//     // ignoreDiacritics: true, // Ignorar acentos
//     shouldSort: true, // Ordenar por puntuación
//     includeMatches: true, // Incluir coincidencias en el resultado, resaltar
//     // findAllMatches: true, // Recorre toda la cadena
//     // minMatchCharLength: 2, // Solo devolvera los resultados con coincidencias mayores
//     // location: 0, // Donde se espera encontrar la búsqueda
//     threshold: 0.4, // que tanto debe parecerse
//     distance: 100, // Proximidad de la coincidencia a la ubicacioń
//     useExtendedSearch: true, //
//     ignoreLocation: true, // no importa en que parte de la cadena aparezca el patrón
//     // ignoreFieldNorm: true,
//     //fieldNormWeight: 0,
// };
//
// export function PruebaSelect() {
//
//     const [data, setData] = useState([]);
//     const [juzgado, setJuzgado] = useState(null);
//     const [match, setMatch] = useState([]);
//     const [searchTerm, setSearchTerm] = useState('');
//
//     const fuse = useMemo(() => new Fuse(data, options), [data]);
//     const arrayTitle = [1,2,3,4,5,6,7,8,9,10,11];
//     //const fuse = new Fuse(data, options);
//     //const  prueba = JSON.parse(localStorage.getItem('pruebaselect')) ?? [];
//     /**
//      * @param item.materia
//      * @param item.materia_id
//      * @param item.juzgados
//      */
//
//     useEffect(() => {
//         const  prueba = JSON.parse(localStorage.getItem('pruebaselect')) || [];
//         if (prueba.length > 0){
//             setData(prueba);
//         } else {
//             axios.get("https://api.enlacejuridico.com.mx/v2/cmx/estatal/juzgados", {
//                 headers : new AxiosHeaders(
//                     {
//                         "X-Fd-Auth-Token" : "019557e8-7fd6-73db-bab6-b834595e96fd"
//                     }
//                 )
//             })
//                 .then((res) => {
//                     /**
//                      * @param j.juzgado
//                      */
//                     const dataMap = res.data.map(
//                         item => ({ label: item.materia, value: item.materia_id, children: item.juzgados.map((j) => ({label : j.juzgado, value: j.clave})) }) //item.juzgados.map((j) => ({label : j.juzgado, value: j.juzgado_id}))
//                     )
//                     setData(dataMap);
//                     localStorage.setItem('pruebaselect', JSON.stringify(dataMap));
//                 }).catch((err) => console.log(err))
//         }
//     }, []);
//
//     function filterResults(results) {
//
//         let resultsNew = [];
//
//         for (const result of results) {
//
//             const { item, matches } = result;
//
//             let resultNew = {};
//
//             // note: group multiple matches per key, otherwise would become separate entries in highest ancestor array if processes separately
//             for (const key of options.keys) {
//
//                 const matchesForKey = matches.filter(({ key: k }) => k === key);
//
//                 if (matchesForKey.length) {
//                     const valuesForKey = matchesForKey.map(({ value }) => value);
//
//                     const resultForKey = deepFilter(item, key.split("."), obj => valuesForKey.some(value => obj === value));
//
//                     resultNew = deepMerge(resultNew, resultForKey);
//                 }
//             }
//
//             resultsNew.push(resultNew);
//         }
//
//         return resultsNew;
//     }
//
//     const itemsFuse = useMemo(() => {
//         if (searchTerm.length > 0) {
//
//             const fuseSearch = fuse.search(searchTerm);
//
//             const res = filterResults(fuseSearch);
//
//             if (res.length > 0) {
//
//                 setMatch(searchTerm.split(" "));
//                 return res;
//
//             } else{
//
//                 return [
//                     {
//                         label : "Sin coincidencias",
//                         value: 'notfound',
//                     }];
//             }
//         } else{
//             return data;
//         }
//     },[searchTerm, fuse, data]);
//
//     function renderTree(tree){
//         return(
//             <>
//                 <div className="rs-search-box">
//                     <div className="rs-input-group rs-input-group-inside">
//                         <input id={'inputSearch'} placeholder={"Búsqueda de juzgados"} className={"rs-search-box-input rs-input"} value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)}/>
//                         <span className="rs-input-group-addon">
//                             <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 16 16" fill="currentColor" aria-hidden="true" focusable="false" className="rs-search-box-icon rs-icon" aria-label="search" data-category="action">
//                                 <path d="M6.5 1a5.5 5.5 0 1 1 0 11 5.5 5.5 0 1 1 0-11m0 1a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9"></path>
//                                 <path d="M9.646 9.646a.5.5 0 0 1 .638-.058l.069.058 4.5 4.5a.5.5 0 0 1-.638.765l-.069-.058-4.5-4.5a.5.5 0 0 1 0-.707"></path>
//                             </svg>
//                         </span>
//                     </div>
//                 </div>
//                 <div>
//                     {tree}
//                 </div>
//             </>
//         )
//     }
//
//     function renderTreeNode(treeNode){
//         return (
//             <Highlight query={match}>
//                 {treeNode.label}
//             </Highlight>
//         )
//     }
//
//
//     if (data.length > 0) {
//         return (
//             <>
//                 <style type={'text/css'}>
//                     {`
//                         .rs-tree-node-disabled .rs-tree-node-label, .rs-tree-node-disabled>.rs-tree-node-label {
//                             color: #b6b7b8;
//                             color: black;
//                             cursor: not-allowed;
//                             font-weight: 700;
//                         }
//                     `}
//                 </style>
//                 <div className={'py-6'}>
//                     <TreePicker
//                         searchable={false}
//                         virtualized={true}
//                         defaultExpandAll={true}
//                         disabledItemValues={arrayTitle}
//                         data={itemsFuse}
//                         style={{width: 300}}
//                         placeholder="Juzgados"
//                         onChange={(value) => setJuzgado(value)}
//                         id={"treeFD"}
//                         name={"treeFD"}
//                         renderTree={renderTree}
//                         renderTreeNode={renderTreeNode}
//                     />
//                     {juzgado && <span>{juzgado}</span>}
//                 </div>
//             </>
//         );
//     }
// }
//
// /*
//  * Filter array of object property or that don't contain nested value
//  * beware: recursive!
// */
// export function deepFilter(obj, key, testFn) {
//     const [head, ...rest] = key;
//
//     // assumes is object or array
//     if (key.length) {
//
//         if (Array.isArray(obj)) {
//             const res = obj
//                 .map(e => deepFilter(e, key, testFn))
//                 .filter(e => e !== undefined);
//
//             return res.length !== 0 ? res : undefined;
//         } else {
//             const val = deepFilter(obj?.[head], rest, testFn);
//
//             return val !== undefined ? { ...obj, [head]: val } : undefined;
//         }
//
//         // assumes is primitive value or array
//     } else {
//
//         if (Array.isArray(obj)) {
//             const res = obj.filter(e => testFn(e));
//             return res.length !== 0 ? res : undefined;
//         } else {
//             return testFn(obj) ? obj : undefined;
//         }
//
//     }
// }
//
//
// /**
//  * Simple deep merge of two objects
//  * Merges source into target, source overwrites target
//  * Returns new object, doesn't mutate inputs
//  * beware: doesn't consider non-enumberable properties, prototype properties, circular dependencies, getter / setter, symbol keys, etc.
//  */
// export function deepMerge(target, source) {
//     function isObjectOrArray(obj) {
//         return obj && typeof obj === "object";
//     }
//
//     function isArray(obj) {
//         return Array.isArray(obj);
//     }
//
//     function recursiveMerge(target, source) {
//         if (isArray(target) && isArray(source)) {
//             // array + array
//             return target.concat(source);
//         } else if (isObjectOrArray(target) && isObjectOrArray(source)) {
//             // array + object OR object + array OR object + object
//             if (isArray(target) || isArray(source)) {
//                 // array + object OR object + array
//                 return source;
//             } else {
//                 // object + object
//                 const newTarget = Object.assign({}, target);
//                 Object.keys(source).forEach(key => {
//                     const targetValue = target[key];
//                     const sourceValue = source[key];
//                     newTarget[key] = deepMerge(targetValue, sourceValue);
//                 });
//                 return newTarget;
//             }
//         } else {
//             // scalar + scalar OR object + scalar OR scalar + object
//             return source;
//         }
//     }
//
//     return recursiveMerge(target, source);
// }

/**
 * Deep merge for multiple objects
 */
// export function deepMergeArr(target, ...source) {
//     const [first, ...rest] = source;
//     const res = deepMerge(target, first);
//     return rest.length > 0 ? deepMergeArr(res, ...rest) : res;
// }
//
//
// const options2 = {
//     keys: ['label', 'children.label'], // Search within the 'label' property of each item
//     threshold: 0.3, // Adjust for desired fuzzy matching sensitivity
// };
//
// function FuzzySearchExample() {
//
//     const  data = JSON.parse(localStorage.getItem('pruebaselect')) || [];
//     const [searchTerm, setSearchTerm] = useState('');
//     const fuse = useMemo(() => new Fuse(data, options2), []);
//
//     const filteredItems = useMemo(() => {
//         if (!searchTerm) {
//             return data; // Show all items if no search term
//         }
//         return fuse.search(searchTerm).map(result => result.item);
//     }, [searchTerm, fuse]);
//
//     return (
//         <div>
//             <Input
//                 placeholder="Search..."
//                 value={searchTerm}
//                 onChange={setSearchTerm}
//             />
//             <TreePicker
//                 searchable={false}
//                 data={filteredItems}
//                 virtualized={true}
//                 style={{ width: 224 }}
//                 placeholder="Select an item"
//             />
//         </div>
//     );
// }

//
// const useUsers = () => {
//     const [users, setUsers] = useState([]);
//     const [loading, setLoading] = useState(false);
//
//     ///////////////// When typing /////////////////
//     async function featUsers(word){
//         // console.log(word);
//         setLoading(true);
//
//          if (word.length > 4){
//             try {
//                 const response = await axiosInstance.get(`finder?query=${word}`);
//                 const arrUsuarios = Object.entries(response.data).map(([id, info]) => {
//                     return {
//                         id,
//                         value : `${id + info[0].id_cliente}`,
//                         label : info[0].cliente[0].cliente, //`${word + info[0].cliente[0].cliente}`,
//                         ...info[0]
//                     };
//                 });
//
//                 setUsers(arrUsuarios);
//                 setLoading(false);
//
//             } catch (error){
//                 console.error(error);
//             }
//         }
//     }
//
//     ///////////////// onKeyDown /////////////////
//     // function featUsers(word){
//     //     setLoading(true);
//     //     if (word.length > 4){
//     //         axiosInstance.get(`finder?query=${word}`)
//     //             .then((res) => {
//     //                 const arrUsr = Object.entries(res.data).map(([id, info]) => {
//     //                     return {
//     //                         id,
//     //                         value : `${id + info[0].id_cliente}`,
//     //                         label : info[0].cliente[0].cliente,
//     //                         ...info[0]
//     //                     }
//     //                 });
//     //
//     //                 setUsers(arrUsr);
//     //                 setLoading(false);
//     //             }).catch((e) => console.error(e))
//     //     }
//     // }
//
//     return [users, setUsers, loading, featUsers];
// };
//
// const IconSearch = () =>{
//     return(
//         <i className="ki-duotone ki-magnifier fs-3 text-gray-500">
//             <span className="path1"></span>
//             <span className="path2"></span>
//         </i>
//     );
// }
// function PruebaSearchBar(){
//
//     const [users, setUsers, loading, featUsers] = useUsers();
//     //const [search, setSearch] = useState(null);
//     const locale = {
//         noResultsText: 'No se encontraron coincidencias',
//         placeholder: 'Buscar...',
//     };
//
//     return (
//         <>
//             <style type={'text/css'}>
//                 {`
//                     .rs-picker-input{
//                         border : 0!important;
//                         background-color: var(--bs-gray-100)!important;
//                     }
//
//                     .rs-picker-input .rs-picker-toggle{
//                         background-color: var(--bs-gray-100)!important;
//                     }
//
//                     .rs-picker-default .rs-picker-toggle.rs-btn {
//                         padding-top: 0.775rem!important;
//                         padding-bottom: 0.775rem!important;
//                     }
//
//                     .rs-picker-toggle-active, .rs-picker.rs-picker-focused{
//                         box-shadow : none!important;
//                     }
//
//                     :focus-visible{
//                         outline : unset!important;
//                     }
//
//                     .rs-picker-toggle-textbox{
//                         background-color: var(--bs-gray-100)!important;
//                     }
//                 `}
//             </style>
//             <InputPicker
//                 data={users}
//                 caretAs={IconSearch}
//                 locale={locale}
//                 cleanable={false}
//                 style={{ width: 258 }}
//                 groupBy={'id'}
//                 searchBy={(keyword, label, item) => true}
//                 onSearch={featUsers}//setSearch
//                 // onKeyDown={(e) => {
//                 //     if (e.key === "Enter"){
//                 //         featUsers(search);
//                 //     }
//                 // }}
//                 onClose={() => setUsers([])}
//                 onSelect={(value, item, event) =>{
//                     console.log(item);
//                     setUsers([]);
//                 }}
//                 renderMenuGroup={(title, item) => {
//                     return(
//                         <div className={'ms-5 text-uppercase'}>{title}</div>
//                     );
//                 }}
//                 renderMenuItem={
//                     /**
//                      * @param label
//                      * @param item
//                      * @param item.activo
//                      * @param item.paquete
//                      * @param item.usuarios
//                      * @param item.hasta
//                      * @param item.costo
//                      * @returns {JSX.Element}
//                      */
//                 (label, item) => {
//                     return(
//                         <div className={"d-flex align-items-center mb-3"}>
//                             <span className={"bullet bullet-vertical h-40px " + (item.activo === 1 ? "bg-success" : "bg-danger")}></span>
//                             <div className={"mx-3"}>
//                                 <SistemaColor sistema={item.paquete[0].sistema}></SistemaColor>
//                             </div>
//                             <div className={"lh-sm"}>
//                             <span className={"btn btn-link p-0 text-start mw-250px min-w-200px d-inline-block text-truncate text-uppercase text-gray-900 text-hover-primary fw-semibold"}>
//                                 {label}
//                             </span>
//                                 <div className={"mw-250px min-w-200px text-truncate d-block text-muted"}>
//                                     {
//                                         item.usuarios && item.usuarios.map((usr, index) => <span key={usr.id_usuario}>{ index + 1 === item.usuarios.length ? `${usr.usuario} ` : `${usr.usuario}, ` } </span>)
//                                     }
//                                 </div>
//                                 <div className={"mt-1 d-flex d-md-none"}>
//                                     <div className={"fw-semibold"}>{item.hasta}</div>
//                                     <div className={"ms-2 fw-bold text-success"}>$ {item.costo}.MXN</div>
//                                 </div>
//                             </div>
//                             <div className={"d-none d-md-flex flex-column"}>
//                                 <div className={"d-block fw-semibold"}>{item.hasta}</div>
//                                 <div className={"d-block fw-bold text-success"}>$ {item.costo}.MXN</div>
//                             </div>
//                         </div>
//                     );
//                 }}
//                 renderMenu={menu => {
//                     if (loading) {
//                         return (
//                             <p className={'m-0 d-block'} style={{ padding: 10, color: '#999', textAlign: 'center' }}>
//                                 <span className="spinner-border text-primary me-2" style={{ width: "1.5rem", height: "1.5rem" }} role="status"></span>
//                                 <span className={"d-block"}>La búsqueda debe ser mayor a 5 caracteres...</span>
//                             </p>
//                         );
//                     }
//                     return menu;
//                 }}
//             />
//         </>
//     );
// }
